import React from "react";
import { graphql } from "gatsby";
import GraphQLErrorList from "../../../../components/graphql-error-list";
import ResourcesStoriesGrid from "../../../../components/resources-stories-grid";
import SEO from "../../../../components/seo";
import Layout from "../../../../containers/layout";
import { mapEdgesToNodes, filterOutDocsWithoutSlugs } from "../../../../lib/helpers";
import { Link } from "gatsby";


export const query = graphql`
  query enStoriesCommunity {
    projects: allSanityEnStories(filter: {entity: {eq: "community"}}, limit: 12){
      edges {
        node {
          subtitle
          id
          publishedAt
          mainImage {
            asset {
              _id
            }
            alt
          }
          title
          slug {
            current
          }
          writer {
            name
          }
          entity
        }
      }
    }
  }
`;



const storiesCommunity = props => {
  const { data, errors } = props;
  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }
  const projectNodes = data && data.projects && mapEdgesToNodes(data.projects).filter(filterOutDocsWithoutSlugs);
  const language = 'en';
  const canonical = [
    {
      rel: "canonical",
      href: "https://crema.cm/en/resources/stories/community/"
    },
    {
      rel: "alternate",
      href: "https://crema.cm/en/resources/stories/community/",
      hrefLang: 'en'
    },
    {
      rel: "alternate",
      href: "https://crema.cm/es/recursos/historias/comunidad/",
      hrefLang: 'es'
    },
    {
      rel: "alternate",
      href: "https://crema.cm/en/resources/stories/community/",
      hrefLang: 'x-default'
    },
  ];
  const ogurl = "https://crema.cm/en/resources/stories/community/";
  return (
    <Layout language={language} topMenu="stories">
      <SEO 
        lang={language} 
        title="All the stories about the Crema community - Crema" 
        description="All the stories, articles and blogpost about the community of freelancers and independent professionals."
        canonical={canonical} 
        keywords="" 
        ogurl={ogurl}
        index="noindex, nofollow"
      />
      {language && language === 'es' && 
        <div className="resources-context-menu">
          <ul>
            <li className="selected"><Link to="/es/recursos/historias">Todas las Historias</Link></li>
            <li><Link to="/es/recursos/historias/tutoriales">Campus Crema</Link></li>
            <li><Link to="/es/recursos/historias/tips">Tips</Link></li>
            <li><Link to="/es/recursos/historias/comunidad">Comunidad</Link></li>
            <li><Link to="/es/recursos/historias/compania">Compañia</Link></li>
          </ul>
        </div>
        }
        {language && language === 'en' && 
        <div className="resources-context-menu">
          <ul>
            <li><Link to="/en/resources/stories">All the stories</Link></li>
            <li><Link to="/en/resources/stories/how-to">Campus Crema</Link></li>
            <li><Link to="/en/resources/stories/tips">Tips</Link></li>
            <li className="selected"><Link to="/en/resources/stories/community">Community</Link></li>
            <li><Link to="/en/resources/stories/company">Company</Link></li>
          </ul>
        </div>
        }
      {projectNodes && projectNodes.length > 0 && <ResourcesStoriesGrid nodes={projectNodes} language={language} />}

    </Layout>
  );
};

export default storiesCommunity;
